import { useEffect, useState } from 'react';
import { IWorldMarker } from 'react-give-me-map';

export type MarkerInCreation = { marker: IWorldMarker; isDone: boolean };

interface Props {
    onMarkerDone: (marker: IWorldMarker | null) => void;
}

export const useMarkerCreation = (props: Props) => {
    const [markerInCreation, setMarkerInCreation] = useState<MarkerInCreation | null>(null);

    useEffect(() => {
        if (markerInCreation?.isDone) {
            const marker = markerInCreation.marker;
            setMarkerInCreation(null);
            props.onMarkerDone(marker);
        }
    }, [markerInCreation?.isDone]);

    return {
        markerInCreation: markerInCreation?.marker,
        initiateNewMarker: (props: MarkerInCreation) => {
            setMarkerInCreation(props);
        },
        finishNewMarker: (marker: IWorldMarker) => {
            setMarkerInCreation({ marker, isDone: true });
        },
        removeMarkerCreation: () => {
            setMarkerInCreation(null);
            props.onMarkerDone(null);
        }
    };
};
